module.exports = __webpack_public_path__ + "static/media/intro.630d9d7b.mp4";